import { extendTheme } from "@chakra-ui/react";

export const colors = {
  primary: "#325146",
  secondary: "#5A8A79",
  opal: "#A9CBBF",
  aero: "#C3E7DA",
  forest: "#039038",
  ocean: "#23C088",
  red: "#E10951",
  brown: "#EB9755",
  mint: "#E9F2EF",
  powder: "#F6F9F7",
  cultered: "#F6F6F6",
  footer: "#5B6963",
};
const theme = {
  colors: {
    primary: "#325146",
    secondary: "#5A8A79",
    opal: "#A9CBBF",
    aero: "#C3E7DA",
    forest: "#039038",
    ocean: "#23C088",
    red: "#E10951",
    brown: "#EB9755",
    mint: "#E9F2EF",
    powder: "#F6F9F7",
    cultered: "#F6F6F6",
    footer: "#5B6963",
  },
  fontSizes: {
    md: "1em",
    lg: "1.25rem",
    xl: "2.25rem",
  },
  layout: {
    header: {
      height: "4em",
      heightDesk: "5.5em",
      menu: {
        spacing: ".75em",
        secondaryMenuSpacing: "1.5em",
      },
    },
    gutter: "8em",
  },
  fonts: {
    heading: "Atten Round New ExtraBold",
    secondMenu: "Atten Round New Regular",
    body: "Neuzeit Grotesk Regular",
  },
};

export default extendTheme(theme);
